import { height } from "@mui/system";
import React, { useContext, useState } from "react";
import AuthContext from "../context/userAuth.context";
import { useHistory } from "react-router";
import "../css/login.scss";
import Checkbox from "@mui/material/Checkbox";
//import { useHistory } from "react-router";
import FormControlLabel from "@mui/material/FormControlLabel";
export const Login = (props) => {
  const history = useHistory();
  const [rememberMe, setrememberMe] = useState(true);
  const username = useFormInput("");
  const password = useFormInput("");
  const {
    authenticationData,
    setAuthenticationData,
    apiBaseurl,
    setExpiryCountdown,
    setRole,
    setUserData,
    Access,
    setAccess,
  } = useContext(AuthContext);

  const [LoginError, setLoginError] = useState({
    status: false,
    text: "",
  });

  const [LoginInProcess, setLoginInProcess] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    setLoginInProcess(true);

    fetch(authenticationData.ApiBaseURL + "/api/Account/Login", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      body: JSON.stringify({
        UserName: username.value,
        Password: password.value,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        setLoginInProcess(false);
        setLoginError({
          status: false,
          text: "",
        });
        let userObj = {
          email: data.email,
          userName: data.userName,
          id: data.User_Id,
        };
        setUserData(userObj);
        setRole(data.Role);
        setAccess(data.AccessLevel);
        let expireIn_ms = parseInt(data.expires_in);
        setTimeout(() => {
          setExpiryCountdown(true);
        }, expireIn_ms - 20000);

        setAuthenticationData({
          authenticationData: data,
          ApiBaseURL: apiBaseurl,
          isAuthenticated: true,
        });

        localStorage.setItem(
          "animation_studio_2.0_access_token",
          JSON.stringify(data)
        );

        // history.push({
        //   pathname: '/dashboard',
        //   state: {
        //     tags: 'testing Complete'
        //   }
        // });
        // props.history.push('/dashboard');
      })
      .catch(
        (error) => (
          setLoginInProcess(false),
          setLoginError({
            status: true,
            text: "Invalid UserName or Password.",
          }),
          console.log(error),
          localStorage.removeItem("animation_studio_2.0_access_token")
        ) // Handle the error response object
      );
  };

  return (
    <>
      <div className="limiter">
        <div className="container-login100">
          <div className="wrap-login100">
            <div
              className="login100-more"
              style={{ backgroundImage: "url('images/bg-01.svg')" }}
            >
              <div className="p-5">
                <h1 className="headlineCustom">
                  <span className="primaryColor">Create ,</span> Innovate...
                  Animate.
                </h1>
              </div>
            </div>

            <form className="login100-form validate-form">
              <span className="login100-form-title mb-4">
                <img className="logoLogin mb-3" alt="" src="images/Logo.png" />
              </span>
              <span className="login100-form-title mb-5 primaryColor">
                Login to continue
              </span>

              <div
                className="wrap-input100 validate-input"
                data-validate="Valid email is required: ex@abc.xyz"
              >
                <input
                  className="input100 has-val"
                  type="text"
                  name="email"
                  {...username}
                />
                <span className="focus-input100"></span>
                <span className="label-input100">Email</span>
              </div>

              <div
                className="wrap-input100 validate-input"
                data-validate="Password is required"
              >
                <input
                  className="input100 has-val"
                  type="password"
                  name="pass"
                  {...password}
                />
                <span className="focus-input100"></span>
                <span className="label-input100">Password</span>
              </div>

              <div className="flex-sb-m mb-4">
                <div className="contact100-form-checkbox">
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        onClick={(e) => setrememberMe(e.target.checked)}
                        checked={rememberMe}
                      />
                    }
                    label="Remember me"
                  />
                </div>
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    history.push("./forgotpassword");
                  }}
                >
                  <span className="txt1">Forgot Password?</span>
                </div>
              </div>

              <div className="container-login100-form-btn mb-2">
                <button className="login100-form-btn" onClick={handleLogin}>
                  {LoginInProcess && (
                    <span>
                      Validating
                      <div
                        className="spinner-border text-light"
                        role="status"
                        style={{
                          width: "15px",
                          height: "15px",
                          marginLeft: "5px",
                        }}
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </span>
                  )}
                  {!LoginInProcess && <span>Login</span>}
                </button>
              </div>

              {LoginError.status && (
                <div className="error-noti mb-5">
                  <label className="text-white">{LoginError.text}</label>
                </div>
              )}

              <div className="text-center mb-4">
                <br></br>
                <span className="txt2">
                  <strong>
                    *Login details are sent to your email after purchase.
                  </strong>
                </span>
                <br></br>
                <br></br>
                <span>
                  <a
                    style={{ color: "blue" }}
                    href="https://app.toons.ai/support/"
                    target="_blank"
                  >
                    Contact Support
                  </a>
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

const useFormInput = (initialValue) => {
  const [value, setValue] = useState(initialValue);
  const handleChange = (e) => {
    setValue(e.target.value);
  };
  return {
    value,
    onChange: handleChange,
  };
};

export default Login;
